module.exports = __webpack_public_path__ + "img/ant.3d7f1c3d.svg";